import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const Container = (props) => (
  <Box display="inline-block" mr="10px">
    {props.children}
  </Box>
);

Container.propTypes = {
  children: PropTypes.shape({}).isRequired,
};

export default Container;
